export default "__VITE_ASSET__M9hWoVfg__"